export default __webpack_public_path__ + "static/media/hair_rainbowwig.9f81c46f.png";